// Redireciona para a tela de login. Ela mora na raiz ('/') tanto no navegador
// (BrowserRouter) quanto no app Electron (HashRouter sob file://, onde a raiz é
// '#/'). Usamos a raiz — nunca '/login' — para evitar caminhos duplicados como
// '/login/login' e manter um único ponto de entrada.

export function redirectToLogin(): void {
  if (typeof window === 'undefined') return;

  const isDesktop = (window as any).desktop?.isElectron === true;

  if (isDesktop) {
    // No Electron navegamos pelo hash; '#/' é a tela de login.
    const hash = window.location.hash;
    if (hash !== '' && hash !== '#' && hash !== '#/') {
      window.location.hash = '#/';
    }
    return;
  }

  if (window.location.pathname !== '/') {
    window.location.href = '/';
  }
}
